class AccountService {
    /*@ngInject*/
    constructor($cookies) {
        this.$cookies = $cookies;
        this.accountNumber = this.$cookies.get('reece-account-number') ? JSON.parse(this.$cookies.get('reece-account-number')) : null;
        this.userProfile = this.$cookies.get('reece-user-profile') ? JSON.parse(this.$cookies.get('reece-user-profile')) : null;
    }

    isLoggedInUser() {

        if(this.userProfile !== null && this.userProfile.type) {
            return true;
        }

        return false;
    }

    isTradeUser() {

        if(this.userProfile !== null && this.userProfile.type === 'trade' && this.isCurrentAccount()) {
            return true;
        }

        return false;
    }

    isTradeUnlinkedUser() {

        if(this.userProfile !== null && this.userProfile.type === 'trade' && !this.isCurrentAccount()) {
            return true;
        }

        return false;
    }

    isRetailUser() {

        if(this.userProfile !== null && this.userProfile.type === 'homeowner') {
            return true;
        }

        return false;
    }

    isCurrentAccount() {

        var accountNumber = this.accountNumber ? this.accountNumber.toString() : null;
        var currentAccountNumber = typeof this.userProfile.currentAccount !== 'undefined' ? this.userProfile.currentAccount.accountNumber.toString() : null;

        if(accountNumber === null || currentAccountNumber === null) {
            return false;
        }

        if(this.accountNumber.toString() === this.userProfile.currentAccount.accountNumber.toString()) {

            return true;
        }

        return false;
    }
}

export default AccountService;


// WEBPACK FOOTER //
// ./src/app/services/account-service.js